import { t } from "@/i18n-js/instance";
import type { Plan } from "@circle-react/types/Plan";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { isCurrent } from "@/react/helpers/plansHelpers";
import { planAmountWithCurrencySymbolPrefix } from "@/react/helpers/planHelpers";

const localeRoot = "pricing_plans.plan_settings.plan_selection.plan_selector";

interface PlanMonthlyPriceProps {
  plan: Plan;
}

export const PlanMonthlyPrice = ({ plan }: PlanMonthlyPriceProps) => {
  const isCurrentPlan = isCurrent(plan.plan_action);
  const shouldShowStrikeThrough =
    plan.is_on_offer &&
    !isCurrentPlan &&
    plan.plan_coupon?.discounted_monthly_price;

  const displayPrice = shouldShowStrikeThrough
    ? planAmountWithCurrencySymbolPrefix(
        plan.plan_coupon?.discounted_monthly_price || "",
        plan.currency,
      )
    : plan.display_base_monthly_amount;

  return (
    <div className="flex flex-row items-center gap-1 align-middle">
      {shouldShowStrikeThrough && (
        <Typography.BodyMd
          weight="font-normal"
          color="text-slate-400 dark:text-slate-400"
          size="text-normal"
          textTransform="line-through"
        >
          {plan.display_base_monthly_amount}
        </Typography.BodyMd>
      )}
      <Typography.TitleMd weight="font-bold">{displayPrice}</Typography.TitleMd>
      <Typography.BodyMd
        weight="font-normal"
        color="text-slate-700 dark:text-slate-300"
        size="text-sm"
      >
        {t(`${localeRoot}.monthly_interval`)}
      </Typography.BodyMd>
    </div>
  );
};
